














































































import Vue from 'vue';

export default Vue.extend({
  'name': 'AdminDuplicates',
  data () {
    return {
      'loading': false,
      'error': null as string | null,
      'items': [] as any[],
      'total': 0,
      'page': 1,
      'pageSize': 20,
      'keepIds': {} as Record<number, number>,
      'actingId': 0 as number
    };
  },
  'methods': {
    refresh () {
      this.loading = true;
      this.error = null;
      this.axios.get('admin/duplicates', { 'params': { 'page': this.page, 'pageSize': this.pageSize } })
        .then((res: any) => {
          const r = res.data.result || {};
          this.items = r.items || [];
          this.total = r.total || 0;
        })
        .catch((e: any) => { this.error = e?.response?.data?.message || 'Failed to load duplicates.'; })
        .finally(() => { this.loading = false; });
    },
    merge (pairId: number) {
      const keepId = this.keepIds[pairId];
      if (!keepId) return;
      if (!confirm(`Merge: keep customer #${keepId} and consolidate the other one's warranties into it?`)) return;
      this.actingId = pairId;
      this.axios.post(`admin/duplicates/${pairId}/merge`, { 'keepCustomerId': keepId })
        .then(() => { this.refresh(); })
        .catch((e: any) => { alert(e?.response?.data?.message || 'Merge failed.'); })
        .finally(() => { this.actingId = 0; });
    },
    dismiss (pairId: number) {
      if (!confirm('Mark this pair as a false positive?')) return;
      this.actingId = pairId;
      this.axios.post(`admin/duplicates/${pairId}/dismiss`)
        .then(() => { this.refresh(); })
        .catch((e: any) => { alert(e?.response?.data?.message || 'Dismiss failed.'); })
        .finally(() => { this.actingId = 0; });
    },
    formatDate (s: string): string {
      if (!s) return '—';
      const d = new Date(s);
      const pad = (n: number) => String(n).padStart(2, '0');
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
    }
  },
  mounted () { this.refresh(); }
});
